module.exports = __webpack_public_path__ + "img/logo.75d35701.png";